import { ExpiryDate } from 'frames-react';
import { useIntl } from 'react-intl';

import { DebitCardFieldWrapper } from '../../DebitCardFieldWrapper';

export const ExpiryDateField = () => {
    const intl = useIntl();

    return (
        <DebitCardFieldWrapper
            label={intl.formatMessage({
                id: '_.link_debit_card.expiry_date',
                defaultMessage: 'Expiry date'
            })}
            htmlFor="expiryDate"
        >
            {/* Stripe adds .StripeElement automatically — CheckoutElement mirrors that so both processors can be styled uniformly */}
            <ExpiryDate
                className="CheckoutElement"
                data-testid="checkout-expiry-date"
            />
        </DebitCardFieldWrapper>
    );
};
